import script from "./solution-for-creator.vue?vue&type=script&setup=true&lang=js"
export * from "./solution-for-creator.vue?vue&type=script&setup=true&lang=js"

import "./solution-for-creator.vue?vue&type=style&index=0&id=0c459373&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/ciyc-web-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c459373"]])

export default __exports__